import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { CriminalHistoryFormValues } from "./interface";

interface EditFieldsProps {
  formValues: CriminalHistoryFormValues;
  handleChange: (
    field: keyof CriminalHistoryFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        multiline
        label="Drug or alcohol use"
        value={formValues.drugAlcoholUse}
        onChange={handleChange("drugAlcoholUse")}
        helperText="Is the client or anyone in the home, under the influence of drugs or alcohol? If yes, explain & note if any treatment measures have taken place."
      />

      <LabeledTextArea
        multiline
        label="Criminal and legal history"
        value={formValues.criminalLegalHistory}
        onChange={handleChange("criminalLegalHistory")}
        helperText="Does the client or anyone in the home have any current/past criminal charges filed, or completed time in jail? If yes, explain."
      />
    </Grid>
  );
};

export default EditFields;
